// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import {Plugins} from '@capacitor/core';

const {Device} = Plugins;

export const environment = {
    production: false
};

export let APP_SHORT_NAME = 'LM';
export let APP_NAME = 'Lift Manager';
export let SOLUTION_URL = 'https://liftmanager.arithmetic.fr';
export let SERVER_URL = 'https://liftmanager.arithmetic.fr';

export const fillAppInfos = async () => {
    SERVER_URL = SOLUTION_URL;
};
